(() => {
  const irelandDate = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Dublin', year: 'numeric', month: '2-digit', day: '2-digit' });
  const shortDate = new Intl.DateTimeFormat('en-IE', { timeZone: 'UTC', day: 'numeric', month: 'short' });
  const fullDate = new Intl.DateTimeFormat('en-IE', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  const workingDate = (now, days) => {
    const parts = Object.fromEntries(irelandDate.formatToParts(now).filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
    const date = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
    for (let counted = 0; counted < days;) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) counted++;
    }
    return date;
  };

  if (!customElements.get('cf-delivery-summary')) {
    customElements.define('cf-delivery-summary', class extends HTMLElement {
      connectedCallback() {
        this.update = () => {
          for (const [key, days] of [['standard', 7], ['expedited', 2]]) {
            const target = this.querySelector(`[data-cf-summary-${key}]`);
            if (!target) continue;
            const source = document.querySelector(`.cf-delivery-estimates [data-cf-${key}]`);
            const estimate = workingDate(new Date(), days);
            const text = source?.textContent.trim() || shortDate.format(estimate);
            if (target.textContent !== text) target.textContent = text;
            target.setAttribute('aria-label', source?.getAttribute('aria-label') || fullDate.format(estimate));
          }
        };
        this.update();
        const banner = document.querySelector('.cf-delivery-estimates');
        if (banner) {
          this.observer = new MutationObserver(this.update);
          this.observer.observe(banner, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label'] });
        }
        this.interval = setInterval(this.update, 60000);
        document.addEventListener('visibilitychange', this.update);
        window.addEventListener('pageshow', this.update);
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.update);
        window.removeEventListener('pageshow', this.update);
      }
    });
  }

  if (!customElements.get('cf-mobile-purchase')) {
    customElements.define('cf-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.info = document.getElementById(`ProductInfo-${this.dataset.section}`);
        this.button = this.querySelector('button');
        this.price = this.querySelector('[data-cf-sticky-price]');
        if (!this.info || !this.button || !this.price) return;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.queue = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
        };
        this.submit = () => {
          this.sync();
          const native = this.nativeButton();
          if (this.button.disabled || !native) return;
          this.submittedFromSticky = true;
          native.click();
          this.sync();
        };
        this.button.addEventListener('click', this.submit);
        this.observer = new MutationObserver(this.queue);
        this.observer.observe(this.info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'value'] });
        this.mobile.addEventListener('change', this.queue);
        window.addEventListener('scroll', this.queue, { passive: true });
        window.addEventListener('resize', this.queue, { passive: true });
        this.sync();
      }
      nativeButton() { return document.getElementById(`ProductSubmitButton-${this.dataset.section}`); }
      sync() {
        const native = this.nativeButton();
        const form = native?.form;
        const currentPrice = document.getElementById(`price-${this.dataset.section}`);
        const physical = currentPrice?.querySelector('[data-cf-physical="true"]');
        const selectedId = form?.querySelector('[name="id"]');
        const busy = native?.getAttribute('aria-disabled') === 'true' || native?.classList.contains('loading');
        this.button.disabled = !native || native.disabled || busy || !selectedId?.value || selectedId.disabled;
        this.button.textContent = native?.querySelector('span')?.textContent.trim() || this.dataset.unavailable;
        this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
        this.price.textContent = currentPrice?.querySelector('.price-item--regular')?.textContent.trim() || '';
        const error = this.info.querySelector('.product-form__error-message-wrapper:not([hidden])');
        if (error && this.submittedFromSticky) {
          error.scrollIntoView({ block: 'center', behavior: 'smooth' });
          this.submittedFromSticky = false;
        }
        this.hidden = !this.mobile.matches || !physical || !native || native.getBoundingClientRect().bottom > 0 || !!error;
        document.body.classList.toggle('cf-mobile-purchase-visible', !this.hidden);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.mobile?.removeEventListener('change', this.queue);
        window.removeEventListener('scroll', this.queue);
        window.removeEventListener('resize', this.queue);
        this.button?.removeEventListener('click', this.submit);
        document.body.classList.remove('cf-mobile-purchase-visible');
      }
    });
  }
})();
